import React, { useState, useEffect } from 'react';
import { Modal, Form } from 'react-bootstrap';
import NumberFormat from 'react-number-format';
import { sortBy } from 'lodash';

import { ApiServiceServerless } from '../../xhr_libs';
import AddEntityActionButtons from '../forms/AddEntityActionButtons';

export default function EditGHGProjectSavingsProjectModal(props) {
  const {
    show,
    onHide,
    org_id,
    projects,
    updateList,
    showToast,
    existingMeasure,
    ghg_savings_projects,
  } = props;

  const [savingsProject, setSavingsProject] = useState({
    name: null,
    value: null,
    years: null,
    offset_years: 0,
    savings_type: null,
  });
  const [projectIds, setProjectIds] = useState([]);

  const [disabled, setDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setSavingsProject({
      name: existingMeasure.name,
      value: existingMeasure.value,
      years: existingMeasure.years,
      offset_years: existingMeasure.offset_years,
      savings_type: existingMeasure.savings_type,
    });
    setProjectIds(existingMeasure.project_ids);
  }, [existingMeasure]);

  useEffect(() => {
    if (
      savingsProject.name !== null &&
      savingsProject.value !== null &&
      savingsProject.years !== null &&
      savingsProject.value !== 0 &&
      savingsProject.years !== 0 &&
      savingsProject.offset_years !== null &&
      savingsProject.savings_type !== null
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [savingsProject]);

  const handleEditProject = (key, value) => {
    setSavingsProject((prev) => ({ ...prev, [key]: value }));
  };

  const saveProject = () => {
    setIsLoading(true);
    ApiServiceServerless.put(
      `/ghg_projects/project_ghg_savings/${existingMeasure.id}`,
      {
        project_ids: projectIds,
        ...savingsProject,
      },
      { authorization_id: org_id }
    )
      .then((res) => {
        showToast('success', 'Success', 'Savings Project Added');
        updateList(res.data, 'ghg_measures');
      })
      .catch((error) => {
        showToast('danger', 'Error', error);
        throw error;
      })
      .finally(() => {
        onHide();
        setIsLoading(false);
      });
  };

  const updateSet = (values) => {
    let arr = Array.prototype.slice.call(values);
    arr = arr.map((item) => item.value);
    setProjectIds(arr);
  };

  const parseNumber = (val) => {
    const float_val = !isNaN(parseFloat(val.replace(/,/g, '')))
      ? parseFloat(val.replace(/,/g, ''))
      : 0;
    return float_val;
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>Edit Project</Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>
            {'Project Name'}
            <span className='text-warning font-weight-bold pl-1'>*</span>
          </Form.Label>
          <Form.Row>
            <Form.Control
              required
              value={savingsProject.name}
              onChange={(e) => handleEditProject('name', e.target.value)}
            />
          </Form.Row>
        </Form.Group>
        <Form.Group>
          <Form.Label>
            {'MTCO2e/Year '}
            <span className='text-warning font-weight-bold pl-1'>*</span>
          </Form.Label>
          <Form.Row>
            <NumberFormat
              customInput={Form.Control}
              thousandSeparator
              isNumericString
              decimalScale={2}
              fixedDecimalScale
              placeholder={'0.00'}
              value={savingsProject.value}
              onChange={(e) =>
                handleEditProject('value', parseNumber(e.target.value))
              }
            />
          </Form.Row>
        </Form.Group>
        <Form.Group>
          <Form.Label>
            {'Duration (Years) '}
            <span className='text-warning font-weight-bold pl-1'>*</span>
          </Form.Label>
          <Form.Row>
            <NumberFormat
              customInput={Form.Control}
              thousandSeparator
              isNumericString
              decimalScale={0}
              fixedDecimalScale
              placeholder={'0'}
              value={savingsProject.years}
              onChange={(e) =>
                handleEditProject('years', parseNumber(e.target.value))
              }
            />
          </Form.Row>
        </Form.Group>
        <Form.Group>
          <Form.Label>
            {'Offset (Years) '}
            <span className='text-warning font-weight-bold pl-1'>*</span>
          </Form.Label>
          <Form.Row>
            <NumberFormat
              customInput={Form.Control}
              thousandSeparator
              isNumericString
              decimalScale={0}
              fixedDecimalScale
              placeholder={'0'}
              value={savingsProject.offset_years}
              onChange={(e) =>
                handleEditProject('offset_years', parseNumber(e.target.value))
              }
            />
          </Form.Row>
        </Form.Group>
        <Form.Group>
          <Form.Label>
            Project Type
            <span className='text-warning font-weight-bold pl-1'>*</span>
          </Form.Label>

          <Form.Control
            as='select'
            required
            value={savingsProject.savings_type}
            onChange={(e) =>
              handleEditProject('savings_type', parseInt(e.target.value))
            }
          >
            <option key={'opt-null'} value={'null'} hidden>
              -
            </option>
            {Object.keys(ghg_savings_projects).map((type) => (
              <option key={type} value={type}>
                {ghg_savings_projects[type]}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        <Form.Group>
          <Form.Label>Project(s)</Form.Label>
          <Form.Control
            as='select'
            multiple
            defaultValue={projectIds}
            onChange={(e) => updateSet(e.target.selectedOptions)}
          >
            {sortBy(Object.values(projects), ['name'])
              .filter((project) => project.project_type === 'ghg')
              .map((item) => (
                <option key={`project-opt-${item.id}`} value={item.id}>
                  {item.name}
                </option>
              ))}
          </Form.Control>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <AddEntityActionButtons
          onCancel={onHide}
          submitDisabled={disabled}
          onSubmit={saveProject}
          isSubmitting={isLoading}
        />
      </Modal.Footer>
    </Modal>
  );
}
